module.exports = __webpack_public_path__ + "static/media/hair_dryer.e000997a.svg";